import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypePostOrdersDownloadParams } from '~/types/delivery-agency.types';

/**
 * [배송 주문 관리] 주문 목록 전체 엑셀 다운로드 API
 */
const fetchPostOrdersDownload = async (params: TypePostOrdersDownloadParams): Promise<void> => {
  const response = await axiosInstance.post(API_ENDPOINT.DELIVERY_AGENCY.GET_ORDERS_EXCEL_DOWNLOAD, params, {
    responseType: 'blob',
  });

  downloadBlobDataFile(response);
};

/**
 * [배송 주문 관리] 주문 목록 전체 엑셀 다운로드 Mutation Hook
 */
export const usePostOrdersDownloadMutation = () => {
  return useDownloadMutation(fetchPostOrdersDownload);
};
